import _asyncToGenerator from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _regeneratorRuntime from "/workdir/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { useCallback, useContext, useState } from "react";
import axios from "axios";
import { AppExperimentContext } from "@catchoftheday/analytics";
import { Box, Button, Datepicker, Form, Label, LoadingSpinner, Span, Text, TextButton } from "@catchoftheday/cg-components";
import { minusOnePx, useMedia, useTheme } from "@catchoftheday/theme";
import { COPY_INVALID_DATE, date, getFormValidationSchema, getSalesChannel } from "@catchoftheday/utilities";
import { COPY_PERSONAL_DETAILS_UPDATE_FAILURE, COPY_PERSONAL_DETAILS_UPDATE_SUCCESS, COPY_RESET_PASSWORD_ERROR_MESSAGE, RESET_PASSWORD_ENDPOINT } from "../../../const/index.js";
import { useUpdatePersonalDetailsMutation } from "../../../generated/graphql.jsx";
import { triggerToast } from "../../../utilities/toast.jsx";
import { GenderPicker } from "../../pure/personal-details/GenderPicker/GenderPicker.jsx";
import { RequiredInput } from "../../pure/personal-details/RequiredInput/RequiredInput.jsx";
import { jsx as ___EmotionJSX } from "@emotion/react";
export var PersonalDetailsFormContainer = function PersonalDetailsFormContainer(_ref) {
  var host = _ref.host,
      customer = _ref.customer;
  var theme = useTheme();
  var isMobile = useMedia(["(max-width: ".concat(minusOnePx(theme.breakpoints.md), ")")], [true]);

  var _useContext = useContext(AppExperimentContext),
      getExperiments = _useContext.getExperiments;

  var _getExperiments = getExperiments(["account_security_page_mar24"]),
      _getExperiments$exper = _slicedToArray(_getExperiments.experiments, 1),
      accountSecurityExperiment = _getExperiments$exper[0];

  var isCotd = !!host && getSalesChannel(host) === "COTD";

  var _useState = useState(customer),
      formData = _useState[0],
      setFormData = _useState[1];

  var _useState2 = useState(""),
      errorDob = _useState2[0],
      setErrorDob = _useState2[1];

  var _useState3 = useState(false),
      changePasswordLoading = _useState3[0],
      setChangePasswordLoading = _useState3[1];

  var _useUpdatePersonalDet = useUpdatePersonalDetailsMutation({
    onCompleted: function onCompleted(data) {
      var _data$updatePersonalD;

      if (((_data$updatePersonalD = data.updatePersonalDetails) === null || _data$updatePersonalD === void 0 ? void 0 : _data$updatePersonalD.__typename) === "UpdatePersonalDetailsSuccessResponse") {
        var _ref2 = data.updatePersonalDetails || {},
            customerData = _ref2.data,
            message = _ref2.message;

        setFormData({
          email: customerData === null || customerData === void 0 ? void 0 : customerData.email,
          phone: customerData === null || customerData === void 0 ? void 0 : customerData.phone,
          firstName: customerData === null || customerData === void 0 ? void 0 : customerData.firstName,
          lastName: customerData === null || customerData === void 0 ? void 0 : customerData.lastName,
          gender: customerData === null || customerData === void 0 ? void 0 : customerData.gender,
          dob: customerData === null || customerData === void 0 ? void 0 : customerData.dob
        });
        triggerToast({
          isError: false,
          message: message || COPY_PERSONAL_DETAILS_UPDATE_SUCCESS
        });
      } else {
        triggerToast({
          isError: true,
          message: data.updatePersonalDetails.error.message
        });
      }
    },
    onError: function onError() {
      triggerToast({
        isError: true,
        message: COPY_PERSONAL_DETAILS_UPDATE_FAILURE
      });
    }
  }),
      _useUpdatePersonalDet2 = _slicedToArray(_useUpdatePersonalDet, 2),
      updatePersonalDetails = _useUpdatePersonalDet2[0],
      mutationLoading = _useUpdatePersonalDet2[1].loading;

  var changeFormData = function changeFormData(fieldName, value) {
    setFormData(function (prev) {
      return _objectSpread(_objectSpread({}, prev), {}, _defineProperty({}, fieldName, value));
    });
  };

  var handleDatepickerOnChange = function handleDatepickerOnChange(value, context) {
    if (value) {
      var errorMessage = context.validationError ? COPY_INVALID_DATE : "";
      changeFormData("dob", date.format(value || "", "yyyy-MM-dd"));
      setErrorDob(errorMessage);
    } else {
      changeFormData("dob", null);
      setErrorDob("");
    }
  };

  var manualValidationDob = function manualValidationDob() {
    if (!!(formData !== null && formData !== void 0 && formData.dob) && isNaN(new Date(formData.dob).getTime())) {
      setErrorDob(COPY_INVALID_DATE);
      return false;
    }

    setErrorDob("");
    return true;
  };

  var submitForm = useCallback(function () {
    if (formData && manualValidationDob()) {
      updatePersonalDetails({
        variables: {
          input: _objectSpread({}, formData)
        }
      });
    }
  }, [formData, updatePersonalDetails]);

  function handlePasswordChange() {
    return _handlePasswordChange.apply(this, arguments);
  }

  function _handlePasswordChange() {
    _handlePasswordChange = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _response$data, response;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setChangePasswordLoading(true);
              _context.prev = 1;
              _context.next = 4;
              return axios.get(RESET_PASSWORD_ENDPOINT);

            case 4:
              response = _context.sent;

              if (response !== null && response !== void 0 && (_response$data = response.data) !== null && _response$data !== void 0 && _response$data.message) {
                _context.next = 7;
                break;
              }

              throw new Error(COPY_RESET_PASSWORD_ERROR_MESSAGE);

            case 7:
              triggerToast({
                isError: false,
                message: response.data.message
              });
              _context.next = 13;
              break;

            case 10:
              _context.prev = 10;
              _context.t0 = _context["catch"](1);
              triggerToast({
                isError: true,
                message: _context.t0.message
              });

            case 13:
              _context.prev = 13;
              setChangePasswordLoading(false);
              return _context.finish(13);

            case 16:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 10, 13, 16]]);
    }));
    return _handlePasswordChange.apply(this, arguments);
  }

  var gender = formData.gender,
      dob = formData.dob;
  var isLoading = mutationLoading || changePasswordLoading;
  return ___EmotionJSX(Form, {
    onSubmit: submitForm,
    schema: getFormValidationSchema({
      isMobile: isMobile || false,
      isCotd: isCotd
    })
  }, ___EmotionJSX(Box, {
    display: "grid",
    rowGap: 5,
    columnGap: 5,
    gridTemplateColumns: {
      xs: "repeat(1, 1fr)",
      md: "repeat(2, 1fr)"
    }
  }, ___EmotionJSX(RequiredInput, {
    id: "email",
    name: "email",
    label: "Email",
    defaultValue: formData.email || "",
    onChange: function onChange(event) {
      return changeFormData("email", event.target.value);
    }
  }), ___EmotionJSX(RequiredInput, {
    id: "phone",
    name: "phone",
    label: "Phone",
    placeholder: "Your mobile / landline number",
    defaultValue: formData.phone || "",
    onChange: function onChange(event) {
      return changeFormData("phone", event.target.value);
    }
  }), ___EmotionJSX(RequiredInput, {
    id: "firstName",
    name: "firstName",
    label: "First name",
    placeholder: "Your first name",
    defaultValue: formData.firstName || "",
    onChange: function onChange(event) {
      return changeFormData("firstName", event.target.value);
    }
  }), ___EmotionJSX(RequiredInput, {
    id: "lastName",
    name: "lastName",
    label: "Last name",
    placeholder: "Your last name",
    defaultValue: formData.lastName || "",
    onChange: function onChange(event) {
      return changeFormData("lastName", event.target.value);
    }
  }), ___EmotionJSX(Box, {
    gridColumn: "1/2"
  }, ___EmotionJSX(GenderPicker, {
    selected: gender || null,
    onChange: function onChange(gender) {
      return changeFormData("gender", gender);
    }
  })), ___EmotionJSX(Box, {
    gridColumn: "1/2"
  }, ___EmotionJSX(Label, {
    htmlFor: "dob"
  }, "Birthday"), ___EmotionJSX(Datepicker, {
    slotProps: {
      textField: {
        id: "dob",
        name: "dob",
        title: "Birthday",
        placeholder: "DD/MM/YYYY",
        fullWidth: true
      }
    },
    value: dob ? new Date(dob) : null,
    onChange: handleDatepickerOnChange
  }), errorDob && ___EmotionJSX(Text, {
    color: "error",
    fontSize: "small",
    mb: 0,
    mt: 1
  }, errorDob))), (!accountSecurityExperiment || accountSecurityExperiment.bucket === 0) && ___EmotionJSX(TextButton, {
    mt: 6,
    color: "secondary",
    disabled: isLoading,
    onClick: handlePasswordChange
  }, ___EmotionJSX(Span, {
    opacity: isLoading ? 0.7 : 1,
    fontSize: "inherit",
    fontWeight: "inherit"
  }, "Change your password"), isLoading && ___EmotionJSX(LoadingSpinner, {
    display: "inline-block",
    ml: 2,
    verticalAlign: "middle",
    width: "20px",
    height: "20px",
    ringBg: "grey"
  })), ___EmotionJSX(Button, {
    type: "submit",
    maxWidth: 125,
    display: "block",
    mt: 6,
    disabled: isLoading
  }, "Save"));
};